import { styled } from '@mui/material/styles';

import AtomGrid from '../../../atoms/AtomGrid';

export const ContainerInstanceButtonStyled = styled(AtomGrid)(() => ({
  display: 'flex',
  justifyContent: 'center',
}));
